import { z } from 'zod';

/**
 * Team storage usage projection — surfaces the existing
 * `teams.storage_used_bytes` + `LimitsService.getEffectiveLimits`
 * pair to end users so they can see where they sit relative to plan
 * quota.
 *
 * `pct` is `usedBytes / quotaBytes`, clamped 0..100 (returns 0 when
 * quota is 0 to avoid divide-by-zero).  The FE uses it to colour the
 * progress bar (green < 60, amber < 90, red ≥ 90).
 */
export const TeamStorageUsageSchema = z.object({
  usedBytes: z.number().nonnegative(),
  quotaBytes: z.number().nonnegative(),
  pct: z.number().min(0).max(100),
  maxFileSizeBytes: z.number().nonnegative(),
  planCode: z.string(),
  /** Top files by size — capped at 10 for the management UI. */
  topFiles: z.array(
    z.object({
      id: z.string().uuid(),
      name: z.string(),
      sizeBytes: z.number().nonnegative(),
      uploadedBy: z.string().uuid().nullable(),
      uploaderName: z.string().nullable(),
      uploadedAt: z.string(),
    }),
  ),
});
export type TeamStorageUsageProjection = z.infer<typeof TeamStorageUsageSchema>;
